const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"m11.5 12l8.5 6V6m-9 12V6l-8.5 6l8.5 6Z\"/>"
};
exports.__esModule = true;
exports.default = data;
